module.exports = __webpack_public_path__ + "img/search-icon.b9f13a2f.svg";